export default "__VITE_ASSET__C7Tj7WR___"